<template>
  <div id="myGraphDiv2">
    <div style="display: flex; justify-content: space-between">
      <div id="myDiagram2Div" style="flex-grow: 1; " ></div>
    </div>
    <div style="display: flex; justify-content: space-between">
      <div id="myOverviewDiv2"></div>
    </div>
  </div>
</template>

<script>

import * as go from 'gojs'
import { createDiagram, shouldUpdate, goLicenseKey } from '@/graph_parts/tds_diagram'
import { createNodeTemplate } from '@/graph_parts/node_template'
import { grey400, blueGrey600 } from '@/utils/constants'

let myDiagram2 = null
let $ = go.GraphObject.make

function orderTreeNodesByOrdering (ta, tb) {
  const pa = ta.node
  const pb = tb.node
  const da = pa.data
  const db = pb.data
  if ('ordering' in da && 'ordering' in db) {
    const a = parseInt(da.ordering)
    const b = parseInt(db.ordering)
    if (a < b) return -1
    if (a > b) return 1
  }
  return 0
}

function walkTreeForDeepestVisibleLevel (node, level) {
  if (node.isTreeLeaf) {
    return level
  } else {
    let deepest = level
    const childIterator = node.findTreeChildrenNodes()
    if (node.isTreeExpanded) {
      deepest++
      if (childIterator) {
        childIterator.each(child => {
          if (child.isTreeExpanded) {
            const d = walkTreeForDeepestVisibleLevel(child, level + 1)
            if (d > deepest) {
              deepest = d
            }
          }
        })
      }
    }
    return deepest
  }
}

function findDeepest (myDiagram2) {
  let deepest = 1
  myDiagram2.findTreeRoots().each(rootNode => {
    const d = walkTreeForDeepestVisibleLevel(rootNode, 1)
    if (d > deepest) {
      deepest = d
    }
  })
  return deepest
}

function hideNodes (myDiagram2) {
  const deepest = findDeepest(myDiagram2)
  myDiagram2.findTreeRoots().each(rootNode => {
    rootNode.collapseTree(deepest - 1)
  })
  myDiagram2.layoutDiagram(true)
}

function showNodes (myDiagram2, isHide) {
  const deepest = findDeepest(myDiagram2)
  myDiagram2.nodes.each(node => {
    node.isTreeExpanded = true
  })
  myDiagram2.findTreeRoots().each(rootNode => {
    rootNode.collapseTree(deepest + 1)
  })
  myDiagram2.layoutDiagram(true)
}

export default {
  name: 'TreeViewGraph',
  components: {
  },
  props: ['queryJson', 'bus'],
  data () {
    return {
    }
  },
  mounted () {
    this.tdsInit()
  },
  created () {
    this.bus.$on('treeViewIncreaseSemanticLevel', () => {
      showNodes(myDiagram2, false)
    })
    this.bus.$on('treeViewDecreaseSemanticLevel', () => {
      hideNodes(myDiagram2, true)
    })
    this.bus.$on('treeViewCentreDiagram', (newData) => {
      myDiagram2.alignDocument(go.Spot.TopLeft, go.Spot.TopLeft)
    })
  },
  watch: {
    queryJson: async function (v) {
      if (v) {
        const d2 = JSON.parse(v)
        d2.nodeDataArray.forEach(nodeData => {
          if (nodeData.group) {
            nodeData.parent = nodeData.group
          }
        })
        myDiagram2.model = new go.TreeModel(d2.nodeDataArray)
      }
    }
  },
  methods: {
    tdsInit () {
      go.licenseKey = goLicenseKey

      myDiagram2 = createDiagram('myDiagram2Div', 'myOverviewDiv2', false, true)
      myDiagram2.layout = $(go.TreeLayout, {
        angle: 90,
        sorting: go.TreeLayout.SortingAscending,
        comparer: orderTreeNodesByOrdering
      })

      myDiagram2.nodeTemplate = createNodeTemplate(false, false, false)
      myDiagram2.linkTemplate = $(go.Link,
        { routing: go.Link.Orthogonal, corner: 5 },
        $(go.Shape, { stroke: grey400 }),
        $(go.Panel, 'Auto', { segmentIndex: 0, segmentFraction: 0.4, segmentOffset: new go.Point(20, 0) },
          $(go.Shape, 'RoundedRectangle', { fill: 'white', stroke: grey400 }),
          $(go.TextBlock,
            { stroke: blueGrey600 },
            new go.Binding('text', '', i => { return i.fromNode.data.operator }).ofObject()
          )
        )
      )

      myDiagram2.addModelChangedListener(e => {
        if (!e.isTransactionFinished) {
          return
        }
        if (shouldUpdate(e)) {
          this.$emit('queryUpdated', e)
        }
      })
    }
  }
}
</script>

<style lang="scss">
#myGraphDiv2 {
  position: relative;
}
#myOverviewDiv2 {
  position: absolute;
  width:200px;
  height:100px;
  top: 10px;
  right: 10px;
  z-index: 100;
  border: solid 1px white;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/TreeViewGraph.vue